/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { Route, Switch } from "react-router-dom";
import styled from "styled-components";
import { Container, theme } from "@nordcloud/gnui";
import { Header } from "~/layout/Header";
import { ROUTES } from "./routes";
import { MenuBar, Footer } from "~/layout";
import { CustomersPage } from "~/views/customers/CustomersPage";

const layoutHorizontalSpacing = theme.spacing.spacing04;

export function GlobalSwitch() {
  return (
    <Container
      fluid
      css={{
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: layoutHorizontalSpacing,
      }}
    >
      <ApplicationGrid>
        <HeaderWrapper>
          <Header />
        </HeaderWrapper>
        <MenuBar />
        <ApplicationWrapper>
          <Switch>
            <Route path={ROUTES.index} component={CustomersPage} />
          </Switch>
        </ApplicationWrapper>
      </ApplicationGrid>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Container>
  );
}

// cache menu bar & layout dimensions
const menuWidth = theme.spacing.spacing07;
const menuHorizontalPadding = theme.spacing.spacing03;

// `1st calc`: we need to add menuHorizontalPadding twice because we have
// paddingLeft and paddingRight on the menu element

// `2nd calc`: we need to add layoutHorizontalSpacing additionally to mitigate
// issue with right padding on global application container which is wrongly
// interpreted by the grid
const ApplicationGrid = styled.div`
  display: grid;
  gap: ${theme.spacing.spacing04} ${layoutHorizontalSpacing};
  grid-template-columns:
    calc(${menuWidth} + 2 * ${menuHorizontalPadding})
    calc(
      100% -
        (
          ${menuWidth} + 2 * ${menuHorizontalPadding} +
            ${layoutHorizontalSpacing}
        )
    );
  grid-template-areas:
    ". header"
    ". application"
    ". footer";
  width: 100%;
`;

const HeaderWrapper = styled.div`
  margin: 0 -${theme.spacing.spacing04} 0 -${layoutHorizontalSpacing};
  grid-area: header;
`;

const ApplicationWrapper = styled.div`
  grid-area: application;
  width: 100%;

  @media screen and (min-width: 2500px) {
    margin: 0 auto;
    max-width: 2500px;
  }
`;

const FooterWrapper = styled.div`
  grid-area: footer;
  padding-top: ${theme.spacing.spacing05};
`;
